import React from 'react';
import UserInfo from '../../../../../Components/UserInfo/UserInfo';
import { useAppContext } from '../../../../../Services/AppContext';
import Text from '../../../../../Components/Base/Text/Text';
import { ElectronicPrescriptionDetailLatamAddMedicamentFormValues } from './ElectronicPrescriptionDetailLatamAddMedicamentForm';
import RemoveButton from '../../../../../Components/Button/RemoveButton';
import useTranslation from '../../../../../Hooks/useTranslation';
import LinkButton from '../../../../../Components/Button/LinkButton';
import { Theme } from '../../../../../Enums/Theme.enum';

interface ElectronicPrescriptionDetailLatamMedicamentsListProps {
	data: ElectronicPrescriptionDetailLatamAddMedicamentFormValues[];
	onRemove: (id: string) => void;
	onEdit: (id: string) => void;
}

export default function ElectronicPrescriptionDetailLatamMedicamentsList(
	props: ElectronicPrescriptionDetailLatamMedicamentsListProps,
) {
	const { t } = useTranslation();
	const { data, onRemove, onEdit } = props;
	const { userData } = useAppContext();

	const handleRemoveFromList = (id: string) => {
		onRemove(id);
	};

	return (
		<div className='mt-5 mb-3'>
			<table className='table' style={{ fontFamily: 'Rubik, sand-serif' }}>
				<thead>
					<tr>
						<th scope='col'>
							{t(
								'component.electronicPrescriptionDetailLatamMedicamentsList.column1',
							)}
						</th>
						<th scope='col'>
							{t(
								'component.electronicPrescriptionDetailLatamMedicamentsList.column2',
							)}
						</th>
						<th scope='col'>
							{t(
								'component.electronicPrescriptionDetailLatamMedicamentsList.column3',
							)}
						</th>
						<th scope='col'>
							{t(
								'component.electronicPrescriptionDetailLatamMedicamentsList.column4',
							)}
						</th>
						<th scope='col'></th>
						<th scope='col'></th>
					</tr>
				</thead>
				<tbody>
					{data.map((item, index) => (
						<tr key={index}>
							<td>{item?.medicationCode}</td>
							<td>{item?.medicine}</td>
							<td>{item?.referredDiagnosis?.codeLabel}</td>
							<td>
								<UserInfo userId={userData?.id} name />
							</td>
							<td>
								<LinkButton
									title='base.shared.edit'
									theme={Theme.BLUE}
									onClick={() => onEdit(item.id)}
								/>
							</td>
							<td>
								<RemoveButton
									onClick={() => handleRemoveFromList(item.id)}
									confirmationText={
										'component.electronicPrescriptionLatam.removeMedicamentFromPrescriptionConfirmText'
									}
								/>
							</td>
						</tr>
					))}
				</tbody>
			</table>
			{data.length < 1 && (
				<div className='text-center'>
					<Text tx='component.electronicPrescriptionDetailLatamMedicamentsList.noData' />
				</div>
			)}
		</div>
	);
}
